/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatefulObjectLite
 */
export interface StatefulObjectLite {
    /**
     * 
     * @type {string}
     * @memberof StatefulObjectLite
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof StatefulObjectLite
     */
    id: number;
}

/**
 * Check if a given object implements the StatefulObjectLite interface.
 */
export function instanceOfStatefulObjectLite(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function StatefulObjectLiteFromJSON(json: any): StatefulObjectLite {
    return StatefulObjectLiteFromJSONTyped(json, false);
}

export function StatefulObjectLiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatefulObjectLite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'id': json['id'],
    };
}

export function StatefulObjectLiteToJSON(value?: StatefulObjectLite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
    };
}

